module.exports = __webpack_public_path__ + "img/png-1.6159d590.png";